import React from "react";
import EmberlineLogo from "./EmberlineLogo";
import { ArrowDown } from "lucide-react";

export default function Hero() {
  return (
    <section
      id="top"
      className="relative min-h-screen w-full overflow-hidden grain"
      data-testid="hero-section"
    >
      {/* Background — pure dark, cinematic lighting only (no stock imagery) */}
      <div className="absolute inset-0 bg-[#0A0A0A]">
        <div className="absolute inset-0 bg-[radial-gradient(ellipse_at_28%_40%,rgba(217,80,30,0.28),transparent_55%)]" />
        <div className="absolute inset-0 bg-[radial-gradient(ellipse_at_75%_85%,rgba(217,80,30,0.16),transparent_60%)]" />
        <div className="absolute inset-0 bg-gradient-to-b from-black/40 via-transparent to-[#0A0A0A]" />
      </div>

      {/* Top hairline + metadata */}
      <div className="absolute top-24 left-0 right-0 px-6 md:px-12 lg:px-16 z-10">
        <div className="hairline" />
        <div className="max-w-[1400px] mx-auto flex justify-between font-body text-[10px] tracking-[0.4em] uppercase text-zinc-500 mt-3">
          <span data-testid="hero-meta-location">Cocoa, Florida</span>
          <span className="hidden md:inline">Functional Art Meets Backyard BBQ</span>
          <span data-testid="hero-meta-year">MMXXV</span>
        </div>
      </div>

      {/* Content */}
      <div className="relative z-10 max-w-[1400px] mx-auto px-6 md:px-12 lg:px-16 min-h-screen flex flex-col justify-center pt-32 pb-24">
        <div className="max-w-5xl">
          <div className="flex items-center gap-4 mb-8 animate-fade-up">
            <div className="h-px w-12 bg-[#D9501E]" />
            <span className="font-body text-xs tracking-[0.45em] uppercase text-[#FF7A00]">
              Custom Smokers · Reclaimed Steel
            </span>
          </div>

          <EmberlineLogo
            variant="hero"
            className="w-56 sm:w-64 md:w-72 lg:w-80 h-auto -ml-2 mb-2 animate-fade-up drop-shadow-[0_25px_55px_rgba(0,0,0,0.8)]"
          />

          <h1
            className="font-heading uppercase leading-[0.85] tracking-tight text-[13vw] sm:text-[10vw] md:text-[7.5vw] lg:text-[6.5vw] xl:text-[6.5rem] animate-fade-up mt-4"
            style={{ animationDelay: "0.15s" }}
            data-testid="hero-headline"
          >
            <span className="block steel-text">Reclaimed Steel.</span>
            <span className="block">
              <span className="steel-text">Refined by </span>
              <span className="ember-text">Fire.</span>
            </span>
          </h1>

          <p
            className="mt-10 max-w-xl text-zinc-400 text-base md:text-lg leading-relaxed animate-fade-up"
            style={{ animationDelay: "0.35s" }}
            data-testid="hero-subcopy"
          >
            Handcrafted, one-of-one smokers and firecraft forged from upcycled
            industrial steel in a Cocoa, Florida workshop. Built different.
            Built by hand.
          </p>

          <div
            className="mt-10 flex flex-wrap gap-4 animate-fade-up"
            style={{ animationDelay: "0.55s" }}
          >
            <a href="#inquiry" className="btn-ember" data-testid="hero-cta-commission">
              Contact Us
            </a>
            <a href="#builds" className="btn-outline" data-testid="hero-cta-builds">
              See the Work
            </a>
          </div>
        </div>
      </div>

      {/* Scroll indicator */}
      <div className="absolute bottom-10 left-1/2 -translate-x-1/2 z-10 flex flex-col items-center gap-2 text-zinc-500">
        <span className="font-body text-[10px] tracking-[0.4em] uppercase">Scroll</span>
        <ArrowDown size={16} className="animate-bounce" />
      </div>
    </section>
  );
}
